module.exports = __webpack_public_path__ + "static/img/icon-notice.0d6de486.svg";